import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { CookieConsentUserComponent } from './cookie-consent-user.component';

@NgModule({
  declarations: [CookieConsentUserComponent],
  imports: [CommonModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShimanoCookieComponent: {
          component: CookieConsentUserComponent,
        },
      },
    }),
  ],
  exports: [CookieConsentUserComponent],
})
export class CookieConsentUserModule {}
